"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var index_tpl_1 = __importDefault(require("./index.tpl"));
var mack_component_library_1 = require("mack-component-library");
var PageDataContext_1 = require("~contexts/PageDataContext");
var CuratedChoices = function () {
    var _a = (0, PageDataContext_1.usePageData)(), sectionLabel = _a.sectionLabel, sectionsData = _a.sectionsData;
    var sectionTabs = [];
    var n = 1;
    while (true) {
        var label = sectionLabel('truck_tabs', "label_".concat(n));
        var value = sectionLabel('truck_tabs', "value_".concat(n));
        var widget = null;
        if (n === 3) {
            widget = react_1.default.createElement(mack_component_library_1.Icon, { icon: mack_component_library_1.Icons.flash });
        }
        if (!label && !value) {
            break;
        }
        var tabOption = {
            label: label,
            value: value,
            widget: widget
        };
        sectionTabs.push(tabOption);
        n++;
    }
    var sections = sectionTabs
        .map(function (tab) {
        var tabsData = sectionsData("".concat(tab.value, "."));
        return tabsData.map(function (tabData) {
            var specifications = [];
            var i = 1;
            while (true) {
                var labelKey = "details_label_".concat(i);
                var valueKey = "details_value_".concat(i);
                if (!tabData[labelKey] || !tabData[valueKey]) {
                    break;
                }
                specifications.push({
                    label: tabData[labelKey],
                    value: tabData[valueKey]
                });
                i++;
            }
            var buttonLink = tabData.truck_config;
            return {
                title: tabData.title,
                subtitle: tabData.subtitle,
                text: tabData.text,
                image: tabData.gallery_image_url,
                detailSection: {
                    specifications: specifications,
                    image: tabData.details_image_url,
                    buttonLink: buttonLink
                }
            };
        });
    })
        .filter(function (s) { return s.length > 0; });
    return (react_1.default.createElement(index_tpl_1.default, { title: sectionLabel('curated_choices_page', 'title'), body: sectionLabel('curated_choices_page', 'text'), sectionTabs: sectionTabs, heroImage: sectionLabel('curated_choices_page', 'hero_image'), sections: sections }));
};
exports.default = CuratedChoices;
